import chalk from 'chalk';
import Table from 'cli-table3';

export function success(msg: string): void {
  console.log(chalk.green(`\u2714 ${msg}`));
}

export function error(msg: string): void {
  console.error(chalk.red(`\u2718 ${msg}`));
}

export function warn(msg: string): void {
  console.warn(chalk.yellow(`\u26A0 ${msg}`));
}

export function info(msg: string): void {
  console.log(chalk.cyan(`\u2139 ${msg}`));
}

/**
 * Print a formatted table to stdout.
 *
 * @param headers - Column header labels
 * @param rows    - Array of row arrays (one value per column)
 */
export function table(headers: string[], rows: string[][]): void {
  const t = new Table({
    head: headers.map((h) => chalk.bold.cyan(h)),
    style: { head: [], border: [] },
  });

  for (const row of rows) {
    t.push(row);
  }

  console.log(t.toString());
}
